import React, { useContext, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Loading from '../../../shared/Loading';
import useToast from '../../../../hooks/useToast';
import { AuthContext } from '../../../../App';
import { getAgreement } from '../../../../lib/actions/orders';

export default function DownloadAgreement({ order, buttonText, buttonClass }) {
  const auth = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const { makeToast } = useToast();

  const fetchAgreement = (order) => {
    let download;
    download = getAgreement(order, auth.auth);

    setLoading(true);
    download
      .start()
      .then(() => {
        setLoading(false);
      })
      .catch(function (error) {
        let msg = '';
        if (error.request.status === 404) {
          msg = 'Agreement not found, please contact support.';
        } else {
          msg = 'Agreement unavailable, please contact support.';
        }

        makeToast(msg, 'negative-red', ['far', 'octagon-xmark']);
        setLoading(false);
      });
  };

  return (
    <div onClick={() => fetchAgreement(order)} className={buttonClass}>
      <p>{buttonText}</p>
      {loading ? (
        <Loading className="w-5 h-5 ml-2 " />
      ) : (
        <FontAwesomeIcon icon={['far', 'download']} className="ml-2 mb-1" />
      )}
    </div>
  );
}
